import { ApiResponse } from '../../../types/api'
import { UserSaveWrongRoundSummaryRequest } from '../../../types/user'
import { useApiPostMutation } from '../useApi'

export const useUserSaveWrongRoundSummary = () => {
  const mutation = useApiPostMutation<ApiResponse, UserSaveWrongRoundSummaryRequest>()

  return {
    ...mutation,
    mutateAsync: (data: UserSaveWrongRoundSummaryRequest) =>
      mutation.mutateAsync({
        url: '/user/saveWrongRoundSummary',
        data,
      }),
  }
}
